import { Injectable, inject } from '@angular/core';
import { State, StateContext, Action, Selector } from '@ngxs/store';
import { patch, insertItem, removeItem } from '@ngxs/store/operators';
import { ReferralActions } from './referral.action';
import { GenericService } from 'src/app/services/generic.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzMessageService } from 'ng-zorro-antd/message';

@State<any>({
	name: 'ReferralState',
	defaults: {
		referral: [],
		count: 0
	}
})
@Injectable()
export class ReferralState {
	private genericService = inject(GenericService);
	private ngxLoader = inject(NgxUiLoaderService);
	private nzMessage = inject(NzMessageService);


	@Selector()
	static getReferral(state: any) {
		return state;
	}

	@Action(ReferralActions.GetReferral)
	getReferral(context: StateContext<any>, action: ReferralActions.GetReferral) {
		this.ngxLoader.start();
		this.genericService
			.post('ApplicantProtected/GetMyReferrals', action.payload)
			.subscribe((data: any) => {
				this.ngxLoader.stop();
				context.setState(
					patch<any>({
						referral: data.value,
						count: data['@odata.count']
					})
				);
			});
	}
}
